<template>
  <div>
    <van-tabbar v-model="active">
      <!--      请注意使用时 name值需于to值保持一致 确保刷新选中对应的tabbar-->
      <van-tabbar-item name="/home" to="/home" icon="home-o">首页</van-tabbar-item>
      <van-tabbar-item name="/search" to="/search" icon="search">查找</van-tabbar-item>
      <van-tabbar-item name="/user" to="/user" icon="friends-o">圈子</van-tabbar-item>
      <van-tabbar-item name="/service" to="/service" icon="setting-o">设置</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      activePath: '/'
    }
  },
  computed: {
    active: {
      get() {
        return this.$route.path
      },
      set(nVal) {
        return nVal
      }
    }
  }
}
</script>

<style scoped>

</style>
